<template>
  <div class="carousel">
    <div
      class="carousel__wrapper"
      ref="slider"
    >
      <div class="carousel__container">
        <div
          class="carousel__slide"
          v-for="slide in slidesCount"
          :key="`slide-${slide}`"
        >
          <slot :name="`slide-${slide}`" />
        </div>
      </div>
    </div>
    <a
      href="#"
      class="carousel__button carousel__button--prev"
      :aria-label="$t('carousel.prev.button.label')"
      ref="buttonPrev"
    />
    <a
      href="#"
      class="carousel__button carousel__button--next"
      :aria-label="$t('carousel.next.button.label')"
      ref="buttonNext"
    />
    <div
      v-if="pagination && slidesCount > 1"
      class="carousel__pagination"
      ref="pagination"
    />
  </div>
</template>

<script>
  import Swiper, { Navigation, Pagination } from 'swiper';
  import { breakpoints } from '../../variables/variables.js';
  import pigeon from '../../utilities/js/pigeon/pigeon.js';
  import swiperMixin from '../../utilities/vueMixins/swiperMixin/swiperMixin.js';

  export default {
    props: {
      slidesCount: Number,
      slidesPerViewDesktop: {
        type: Number,
        default: 4
      },
      slidesPerViewTablet: Number,
      slidesPerViewMobile: {
        type: Number,
        default: 2
      },
      pagination: {
        type: Boolean,
        default: false
      }
    },
    mixins: [
      swiperMixin
    ],
    mounted() {
      this.createSwiperInstance();
      pigeon.publish('carousel:mounted');
    },
    methods: {
      createSwiperInstance() {
        Swiper.use([Navigation, this.pagination ? Pagination : '']);

        this.swiperInstance = new Swiper(this.$refs.slider, {
          slidesPerView: this.slidesPerViewMobile,
          slidesPerGroup: this.slidesPerViewMobile,
          loop: false,
          wrapperClass: 'carousel__container',
          slideClass: 'carousel__slide',
          grabCursor: true,
          spaceBetween: 20,
          navigation: {
            nextEl: this.$refs.buttonNext,
            prevEl: this.$refs.buttonPrev,
            hiddenClass: 'product-gallery__button--hidden',
            disabledClass: 'product-gallery__button--disabled'
          },
          breakpoints: {
            [breakpoints.tablet]: {
              slidesPerView: this.slidesPerViewTablet ? this.slidesPerViewTablet : this.slidesPerViewDesktop,
              slidesPerGroup: this.slidesPerViewTablet ? this.slidesPerViewTablet : this.slidesPerViewDesktop
            },
            [breakpoints.desktop]: {
              slidesPerView: this.slidesPerViewDesktop,
              slidesPerGroup: this.slidesPerViewDesktop
            },
          },

          simulateTouch: this.isSimulateTouch,
          pagination: this.pagination ? {
            el: this.$refs.pagination,
            dynamicBullets: true,
            clickable: true,
            bulletClass: 'carousel__pagination-bullet',
            bulletActiveClass: 'carousel__pagination-bullet--current',
            clickableClass: 'carousel__pagination-bullet--clickable',
            hideOnClick: false
          } : ''
        });

        this.fixLazyLoadingImages();
      },
      /**
       TODO:
       Swiper clones some slides, if content of the slide is vue component,
       it will not clone js logic for it (events, etc...), because of that, lazy
       loading for duplicated images doesn't work, this function is workaround,
       but it should be done better in the future...
       **/
      fixLazyLoadingImages() {
        const lazyLoadImages = this.$refs.slider.querySelectorAll('.swiper-slide-duplicate .lazy-load-image');

        lazyLoadImages.forEach(lazyLoadImage => {
          const imgSrc = lazyLoadImage.dataset.imgSrc;
          const spans = lazyLoadImage.querySelectorAll('span');
          const imageElement = lazyLoadImage.querySelector('img');

          imageElement.src = imgSrc;
          imageElement.style.opacity = '1';

          spans.forEach(span => {
            span.style.display = 'none';
          });
        });
      }
    }
  };

</script>
